<form [formGroup]="qrBatchForm" (ngSubmit)="handleSubmit()">
  <app-card [cardBodyClasses]="'p-18'">
    <ng-container cardBody>
      <h2 class="form-title mb-7">Nama Batch Pembuatan</h2>
      <app-input-text
        [max]="'100'"
        [required]="true"
        [formControlName]="'batch_name'"
        label="Nama Batch"
        min="3"
        ngDefaultControl
        placeholder="Silahkan input nama batch"
      ></app-input-text>
    </ng-container>
  </app-card>

  <div class="my-7"></div>

  <app-card [cardBodyClasses]="'p-18'">
    <ng-container cardBody>
      <h2 class="form-title mb-7">Produk</h2>

      <ng-template #ctaAddProductTpl>
        <div class="align-items-center d-flex flex-wrap mb-6">
          <label class="col-12 col-form-label col-lg-4 required">Produk</label>
          <div class="col-12 col-lg-8">
            <ng-container [ngTemplateOutlet]="ctaAddProductButton"></ng-container>
          </div>
        </div>
      </ng-template>

      <!--
        Table List Selected Brand Product
      -->
      <ng-container *ngIf="tableSourceBrand.value.length; else ctaAddProductTpl">
        <!-- NoteView: Sync data -->
        <app-note-view
          [color]="'warning-secondary'"
          [text]="'Data produk dapat berubah sewaktu-waktu dari ERP.'"
          [icon]="STRING_CONSTANTS.ICON.IC_DANGER_NONE"
          [extraContent]="true"
        >
          <button mat-raised-button color="primary" class="btn btn-primary" type="button" (click)="handleSyncData()"><span>Sync Data</span></button>
        </app-note-view>

        <div class="my-7"></div>

        <div class="table-responsive">
          <table class="table w-100 gy-5 table-row-bordered" mat-table [dataSource]="tableSourceBrand" [formArrayName]="'list_brand'">
            <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="px-3"
                [ngClass]="{
                  'min-w-70px text-center': tableColumn.key === 'action',
                  'text-center': tableColumn.key === 'qty',
                  'min-w-200px': tableColumn.key !== 'action'
                }"
              >
                {{ tableColumn.title }}
              </th>

              <td mat-cell *matCellDef="let element; let i = index" class="px-3" [formGroupName]="i">
                <ng-container [ngSwitch]="tableColumn.key">
                  <ng-container *ngSwitchCase="'name'">
                    <span>{{ element.name }}</span>
                    <span class="ms-4 badge badge-bg badge__status badge__status--{{ element['status'] }}">
                      {{ element['status_value'] }}
                    </span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'qty'">
                    <app-input-counter [formControlName]="'generate_qty'" [fieldIndex]="i" [max]="MAX_NUMBER_COUNTER" ngDefaultControl></app-input-counter>
                  </ng-container>

                  <div class="text-center" *ngSwitchCase="'action'">
                    <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_TRASH_RED" class="svg-icon svg-icon2 cursor-pointer" (click)="handleRemoveBrand(element, i)"></span>
                  </div>

                  <ng-container *ngSwitchDefault>
                    <span>{{ element[tableColumn.key] }}</span>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="total_text">
              <td mat-footer-cell *matFooterCellDef class="px-3 min-w-200px">
                <span class="fw-bold text-uppercase text-gray-700">Total</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="total_num">
              <td mat-footer-cell *matFooterCellDef class="px-3 text-center">
                <span class="fw-bold">{{ utilitiesService.toThousandConvert((totalQTY | async) ?? '0') }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr mat-footer-row *matFooterRowDef="['total_text', 'total_num']"></tr>
          </table>
        </div>

        <div class="d-flex align-items-center justify-content-center w-100 my-7">
          <ng-container [ngTemplateOutlet]="ctaAddProductButton"></ng-container>
        </div>
      </ng-container>

      <div class="my-7"></div>

      <ng-template [ngTemplateOutlet]="listBoxBrandInput"></ng-template>
    </ng-container>
  </app-card>

  <div class="d-flex align-items-center justify-content-between mt-10 mb-20 button-group">
    <button class="btn btn-outline btn-outline-secondary min-w-150px" (click)="handleCancel()" type="button"><span class="text-primary">Batal</span></button>
    <button mat-raised-button [color]="'primary'" class="btn btn-primary ms-4 min-w-150px" type="submit" [disabled]="qrBatchForm.invalid"><span>Simpan</span></button>
  </div>

  <ng-template #ctaAddProductButton>
    <button type="button" class="btn btn-outline" (click)="handleOpenListBoxBrand()">
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS" class="svg-icon svg-icon-2"></span>
      <span class="text-primary">Tambah Produk</span>
    </button>
  </ng-template>

  <ng-template #listBoxBrandInput>
    <app-input-listbox-brand #listboxBrandComponent [maxSelectChips]="MAX_NUMBER_BRAND" (selectedItems)="handleSelectedItems($event)"></app-input-listbox-brand>
  </ng-template>
</form>

<app-modal-confirm-create #modalConfirmCreate [selectedListBrand]="selectedBrandToCreate"></app-modal-confirm-create>
<app-modal-confirm-cancel #modalConfirmCancel (resetForm)="shouldResetForm($event)"></app-modal-confirm-cancel>
